export const initialState = {
  studentId: '',
  student: null,
  isError: false,
  isDisabled: true,
}

export const RECEIVE_ERROR = 'RECEIVE_ERROR'
export const RECEIVE_STUDENT = 'RECEIVE_STUDENT'
export const RECEIVE_STUDENT_ID = 'RECEIVE_STUDENT_ID'
export const RESET = 'RESET'

export const reducer = (state, action) => {
  switch (action.type) {
    case 'RECEIVE_STUDENT_ID':
      return { ...state, studentId: action.payload }
    case 'RECEIVE_STUDENT':
      return {
        ...state,
        isError: false,
        isDisabled: false,
        student: action.payload,
      }
    case 'RECEIVE_ERROR':
      return {
        ...state,
        isError: true,
        isDisabled: true,
        student: null,
      }
    case 'RESET':
      return { ...initialState }
    default:
      throw new Error()
  }
}
